export default {
  adult: 'Le champ :attribute doit correspondre à une personne de plus de 18 ans.',
  after: {
    custom: 'Le champ :attribute doit être une date postérieure au :date.',
    today: 'Le champ :attribute doit être une date postérieure à aujourd\'hui.'
  },
  afterOrEqual: {
    custom: 'Le champ :attribute doit être une date postérieure ou égale au :date.',
    today: 'Le champ :attribute doit être une date postérieure ou égale à aujourd\'hui.'
  },
  alpha: 'Le champ :attribute doit contenir uniquement des lettres.',
  alphaLower: 'Le champ :attribute doit contenir uniquement des lettres minuscules.',
  alphaUpper: 'Le champ :attribute doit contenir uniquement des lettres majuscules.',
  alphaUpperNum: 'Le champ :attribute doit contenir uniquement des chiffres et des lettres majuscules.',
  alphaDash: 'Le champ :attribute doit contenir uniquement des lettres et des tirets.',
  alphaNumeric: 'Le champ :attribute doit contenir uniquement des chiffres et des lettres.',
  alphaSpace: 'Le champ :attribute doit contenir uniquement des lettres et des espaces.',
  before: {
    custom: 'Le champ :attribute doit être une date antérieure au :date.',
    today: 'Le champ :attribute doit être une date antérieure à aujourd\'hui.'
  },
  beforeOrEqual: {
    custom: 'Le champ :attribute doit être une date antérieure ou égale au :date.',
    today: 'Le champ :attribute doit être une date antérieure ou égale à aujourd\'hui.'
  },
  dateBetween: 'Le champ :attribute doit être une date comprise entre le :date (:first_inclusion) et le :second_date (:second_inclusion).',
  dateEquals: {
    custom: 'Le champ :attribute doit être une date égale au :date.',
    today: 'Le champ :attribute doit être la date d\'aujourd\'hui.'
  }, // No Messages for email
  // email: 'Le champ :attribute doit être une adresse email valide.',
  greaterThan: {
    number: 'La valeur de :attribute doit être supérieure à :number.',
    string: 'Le texte de :attribute doit contenir plus de :number caractères.',
    array: 'Le tableau :attribute doit contenir plus de :number éléments.'
  },
  greaterThanOrEqual: {
    number: 'La valeur de :attribute doit être supérieure ou égale à :number.',
    string: 'Le texte de :attribute doit contenir au moins :number caractères.',
    array: 'Le tableau :attribute doit contenir au moins :number éléments.'
  },
  imei: 'Le champ :attribute doit être un numéro imei valide',
  lessThan: {
    number: 'La valeur de :attribute doit être inférieure à :number.',
    string: 'Le texte de :attribute doit contenir moins de :number caractères.',
    array: 'Le tableau :attribute doit contenir moins de :number éléments.'
  },
  lessThanOrEqual: {
    number: 'La valeur de :attribute doit être inférieure ou égale à :number.',
    string: 'Le texte de :attribute doit contenir au plus :number caractères.',
    array: 'Le tableau :attribute doit contenir au plus :number éléments.'
  },
  numeric: 'Le champ :attribute doit contenir un nombre.',
  decimal: 'Le champ :attribute doit contenir un nombre avec au maximum :number décimales.',
  same: 'Les champs :other et :attribute doivent être identiques.',
  size: {
    number: 'La valeur de :attribute doit être :number.',
    string: 'Le texte de :attribute doit contenir :number caractères.',
    array: 'Le tableau :attribute doit contenir exactement :number éléments.'
  },
  url: 'Le champ :attribute doit être un URL valide.'
}
